import { callExternalEndpoint } from './apiUtils';

export const nearestChimeRegionApi = async () => {
  const response = {
    region: 'us-east-1',
    errorMessage: '',
  };

  try {
    const nearestRegionResponse = await callExternalEndpoint<NearestChimeRegionResponse>(
      'https://nearest-media-region.l.chime.aws',
      'GET'
    );
    //do not log error message so Chennai office can use telehealth on development processes but not production
    if (nearestRegionResponse.region.substring(0, 2) === 'ap' && process.env.ENVIRONMENT !== 'production') {
      response.region = nearestRegionResponse.region;
    } else if (nearestRegionResponse.region.substring(0, 2) === 'us') {
      response.region = nearestRegionResponse.region;
    } else {
      response.errorMessage = `region: ${nearestRegionResponse.region} outside US`;
    }
  } catch (error) {
    response.errorMessage = error as string;
  }
  return response;
};
